// Models
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Validates the required Sprint date range.
 * @param startDate Inclusive Sprint start date.
 * @param finishDate Inclusive Sprint finish date.
 */ export function validateSprintDates(startDate, finishDate) {
    if (Temporal.PlainDate.compare(finishDate, startDate) < 0) {
        throw new Error("Invalid finishDate: finishDate cannot precede startDate.");
    }
}
/**
 * Finds Sprints whose inclusive date ranges overlap the candidate in the same Plan.
 * @param candidate Candidate Sprint range.
 * @param sprints Complete Sprint collection for the candidate Plan.
 * @returns Conflicting Sprints in input order.
 */ export function findOverlappingSprints(candidate, sprints) {
    return sprints.filter((sprint)=>sprint.id !== candidate.id && sprint.planId === candidate.planId && Temporal.PlainDate.compare(candidate.startDate, sprint.finishDate) <= 0 && Temporal.PlainDate.compare(sprint.startDate, candidate.finishDate) <= 0);
}
